export default __webpack_public_path__ + "media/images/react_icons/facebook-5150fe3bb4b3b31d84641dc9c55bc92d.svg";